<template>
  <v-btn
    :disabled="disabled"
    :loading="loading"
    :style="{
      minWidth: '35px',
      maxWidth: '35px',
      minHeight: '35px',
      maxHeight: '35px',
    }"
    :large="large"
    :small="small"
    :color="color"
    v-on="$listeners"
    icon
  >
    <v-icon :small="small">{{ icons }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  props: ["icons", "disabled", "loading", "large", "color", "small"],
};
</script>
